import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Timeline from "./Timeline";

function App() {
  return (
    <div className="App">
      <header className="App-header" style={{ paddingBottom: 0 }}>
        <img src={logo} className="App-logo" alt="logo" />
        <p>Hello!</p>
        <a
          className="App-link"
          href="home.m1dkn1gh7.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Login
        </a>
      </header>

      {/* New: the interactive bit */}
      <Timeline />
    </div>
  );
}

export default App;
